export const IconLoading = ({
  type,
  icon,
  size,
  effect,
  colorClass,
  position,
}) => {
  type = type || "fa-solid";
  icon = icon || "fa-duotone fa-clipboard-list-check";
  size = size || "7x";
  effect = effect || "beat-fade";
  colorClass = colorClass || "et-dark-gray";
  position = position || "absolute";

  return (
    <div
      className={`d-flex flex-column align-items-center justify-content-center w-100 h-100 position-${position}`}
    >
      <i
        className={`fa-${type} ${icon} fa-${size} fa-${effect} ${colorClass}`}
      ></i>
    </div>
  );
};
